import type { IconData } from '@stacksjs/iconify-core'

export const controlButtonsRecord: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default controlButtonsRecord
